import {
    AddressTypesState,
    LOADED_ADDRESSTYPES,
    LOADING_ADDRESSTYPES,
    AddressTypesActionTypes,
    AddressTypesViewModel,
  } from './types';
  
  const initialState = {
    globalAddressTypes: [] as AddressTypesViewModel[],
    loading: false,
    loaded: false,
  };
  
  const reducer = (
    state: AddressTypesState = initialState,
    action: AddressTypesActionTypes
  ): AddressTypesState => {
    switch (action.type) {
      case LOADED_ADDRESSTYPES: {
        return {
          globalAddressTypes: action.payload,
          loading: false,
          loaded: true,
        };
      }
      case LOADING_ADDRESSTYPES: {
        return {
          ...state,
          loading: true,
          loaded: false,
        };
      }
      default: {
        return state;
      }
    }
  };
  
  export default reducer;
  